/**
 * @enum {string}
 */
export const EventType = {
    STARTUP: 'startup',
    LAUNCH_COURSE: 'launch-course',
    // ...
};
